import { colors } from '~/theme/colors';

export const styles = {
  volunteerLink: {
    color: colors.primary[500],
  },
};
